module.exports = __webpack_public_path__ + "static/media/docam.b186dbaa.jpg";